<template>
  <div ref="box" v-loading="loading" class="maxwidht">
    <div v-if="aaa">
      <div class="bgcolor">
        <!-- 悬浮按钮 -->
        <div class="buton2" @click="clickMe" v-if="showClickMe">点我下单 优先发货</div>
        <!-- 轮播 -->
        <div class="showImg" :style="{ height: carouselHeight }">
          <img @mouseover="changeInterval(true)" @mouseleave="changeInterval(false)"
            v-for="(item, index) in carouselList" :key="index" :src="item" alt="暂无图片" v-show="index == currentIndex"
            ref="carouselImg">
          <div class="banner-circle">
            <ul>
              <li @click="changeImg(index2)" v-for="(item, index2) in carouselList" :key="index2"
                :class="index2 == currentIndex ? 'active' : ''"></li>
            </ul>
          </div>
        </div>
        <!-- <el-carousel trigger="click" class="carousel" :height="carouselHeight">
          <el-carousel-item v-for="(item,index) in carouselList" :key="index" >
            <img :src="item" alt="" style="width:100%;height: auto;" ref="carouselImg">
          </el-carousel-item>
        </el-carousel> -->
        <!-- 价格基本信息展示 -->
        <div class="baseInfo">
          <div class="flexMoney">
            <div>￥<span class="money">{{ currentObj.price }}起</span></div>
            <div>热卖5000+件</div>
          </div>
          <div class="desc">
            {{ currentObj.product_info_title }}
          </div>
          <div class="freeFlex">
            <div class="baoyou">包邮</div>
            <div class="freeFlex pay">
              <div class="cartDiv">
                <img src="../assets/shopcart.png" alt="" class="cart">
              </div>
              <div class="">
                验货满意后付款
              </div>
            </div>
          </div>
          <div class="service">
            服务
            <span><i class="el-icon-circle-check"></i>包邮</span>
            <span><i class="el-icon-circle-check"></i>假一赔三 </span>
            <span><i class="el-icon-circle-check"></i>七天退货</span>
            <br><span class="safeguard"><i class="el-icon-circle-check"></i>消费者服务保障</span>
          </div>
        </div>
        <!-- 滚动 -->
        <div class="commonstyle">
          <div class="scanNum">
            {{ people }}人正在浏览 <span>数量有限，先到先得</span>
          </div>
          <div class="sacnContainer">
            <vue-seamless-scroll :data="tableData" class="seamless-warp" :class-option="classOption">
              <div v-for="(item, index) in tableData" :key="index" class="table-body">
                <div class="unit">
                  <div>
                    <img :src="item.url" alt="" class="avatar">
                  </div>
                  <div class="personinfo">
                    <div class="namephone">{{ item.name }} {{ item.phone }}</div>
                    <div>
                      {{ currentObj.product_info_title }}
                    </div>
                  </div>
                  <div class="tobuy" @click="gotobottom">
                    马上抢
                  </div>
                </div>
              </div>
            </vue-seamless-scroll>
          </div>
        </div>
        <!-- 商品详情  售后切换 -->
        <div class="tabs">
          <div @click="changeTab1" :class="acitve ? 'activetab' : ''">商品详情</div>
          <div @click="changeTab2" :class="acitve ? '' : 'activetab'">咨询与售后</div>
        </div>
        <!-- 图文 -->
        <div v-if="acitve">
          <div class="pictext">
            一 图文详情 一
          </div>
          <div v-for="(item, index) in detailList" :key="index">
            <img :src="item" alt="" class="detailimg">
          </div>
        </div>
        <!-- 售后相关问题 -->
        <div v-else class="commonstyle">
          <el-collapse>
            <el-collapse-item title="●我的订单大概多久发货?" name="1" class="explaintitle">
              <div class="explaintext">
                订单的发货时间为您下单之后的72小时内，请您耐心等待。订单状态及物流运转进度可在订单详情中查看，
                普通地区异地物流运转时间3-5天左右，偏远地区异地物流运转时间5-7天左右，如遇特殊情况将会导致延误，
                以物流官网进度为准。若您的订单超出72小时仍未发货，建议您联系商家进行咨询。
              </div>
            </el-collapse-item>
            <el-collapse-item title="●我的订单如何申请换货? " name="2">
              <div class="explaintext">
                若您需办理换货，无需对订单进行任何操作，请您及时联系商家协商换货事宜，向商家索取商品寄回地址信息，
                将商品寄回至商家处，并向商家提供商品寄回有效物流单号，由商家为您安排换货。<br>
                换货要求：保证商品全新，不影响二次销售，商品包装完好，附件、赠品齐全。在寄回包裹中放置小纸条注明您
                的联系方式、订单号，禁止使用“到付”运费支付形式将商品寄回。
              </div>
            </el-collapse-item>
            <el-collapse-item title="●价格说明" name="3">
              <div class="explaintext">
                划线价格：指商品的专柜价，吊牌价，正品零售价，厂商指导价或该商品曾经展示的售卖价，并非原价，仅供参考。<br>
                未划线价格：指商品的实时标价，不因表述的差异改变性质。具体成交价格根据商品参加活动或者会员试用优惠券、
                积分等发生变化，最终以订单结算价格为准。
              </div>
            </el-collapse-item>
          </el-collapse>

        </div>
        <div ref="orderInfo">
          <!-- 订单相关 -->
          <div class="commonstyle">
            <div class="orderInfo">订单信息</div>
            <div class="border">
              <div class="padding orderFlex">
                <div>
                  <img :src="normImg ? normImg : currentObj.picture_src" alt="" class="orderimg">
                </div>
                <div class="orderMoney">
                  <div>
                    {{ normTitle ? normTitle : currentObj.product_info_title }}
                  </div>
                  <div class="red">
                    <div>￥<span class="money">{{ normPrice ? normPrice : currentObj.price }}</span></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="paddingtb">
              {{ currentObj.product_info_title }}
            </div>
            <div class="paddingtb border">
              <div v-for="(item, index) in normList" :key="index" class="normunit" @click="slectNorm(item)"
                :class="form.product_type_code == item.id ? 'activeradio' : 'deactiveradio'">
                套餐：{{ item.product_type_name }}
              </div>
            </div>
            <div class="buynumflex paddingtb">
              <div class="buynum">购买数量</div>
              <div>
                <el-input-number v-model="form.order_num" :precision="0" :min="1" :max="100"
                  @change="changeNum"></el-input-number>
              </div>
            </div>
          </div>
          <!-- 个人信息表单 -->
          <div class="commonstyle">
            <el-form ref="form" :model="form" label-width="90px" label-position="left" :rules="rules">
              <el-form-item label="收货人" prop="receiver_name">
                <el-input v-model="form.receiver_name" placeholder="请输入收货人姓名" maxlength="6" />
              </el-form-item>
              <el-form-item label="联系方式" prop="receiver_tel">
                <el-input v-model="form.receiver_tel" placeholder="请输入11位手机号码" maxlength="11" />
              </el-form-item>
              <el-form-item label="所在区域" prop="receiver_area">
                <div style="width:100%">
                  <el-cascader style="width:100%" v-model="form.receiver_area" :options="options">
                  </el-cascader>
                </div>
              </el-form-item>
              <el-form-item label="详细地址" prop="receiver_address">
                <el-input v-model="form.receiver_address" placeholder="请输入详细地址" />
              </el-form-item>
            </el-form>
          </div>
          <!-- 支付方式 -->
          <div class="commonstyle">
            <div>支付方式</div>
            <div class="payflex">
              <div class="paycontainer">
                <div><img src="../assets/pay.png" alt="" class="payicon"></div>
                <div>货到付款</div>
              </div>
              <div>
                <span><i class="el-icon-circle-check red"></i></span>
              </div>
            </div>
          </div>
          <!-- 包邮实付款 -->
          <div class="commonstyle">
            <div class="flex conmonheight border">
              <div>运费</div>
              <div>包邮</div>
            </div>
            <div class="flex conmonheight border" v-if="useRedBag">
              <div>优惠券</div>
              <div>减{{ discountAmount }}</div>
            </div>
            <div class="flex conmonheight">
              <div>实付款</div>
              <div class="realPay">￥{{ form.order_total }}</div>
            </div>
          </div>
          <!-- 留言提交 -->
          <div class="commonstyle">
            <div class="messageflex">
              <div class="remark">买家留言</div>
              <div>
                <el-input v-model="form.order_notes" placeholder="选填：对快递等的特殊要求" maxlength="50" style="width:280px" />
              </div>
            </div>
            <div class="button" @click="submitForm">
              立即抢购
            </div>
          </div>
          <div class="text-center">
            {{currentObj.company_info}}
          </div>
        </div>

      </div>
    </div>
    <div v-else class="nothing">
      <div><img :src="currentObj.picture_src" alt=""></div>
      <div>{{currentObj.company_info}}</div>
    </div>
    <!-- 优惠券 -->
    <el-dialog :visible.sync="open" width="70%" append-to-body class="dialog">
      <div class="bagcontent" @click="receive">
        <div class="minusmoney">立减{{ discountAmount }}元</div>
      </div>
    </el-dialog>
  </div>
</template>

<script src="../utils/jquery.js"></script>
<script>
  import MobileDetect from "../utils/mobile.min.js";
  import {
    getCityInfo,
    getIp,
    getPageInfo,
    addOrder,
    getConfig,
    getBaiduIp
  } from "../utils/api"
  import citys from '../utils/city.json'
  import CryptoJS from "crypto-js";
  export default {
    name: 'free',
    data() {
      return {
        carouselHeight: '400px',
        useRedBag: false,
        discountAmount: 20,
        open: false,
        showHeight: null,
        showClickMe: true,
        aaa: false,
        loading: true,
        acitve: true,
        classOption: {
          step: 0.5, // 数值越大速度滚动越快(默认1)
          limitMoveNum: 5, // 开启无缝滚动的数据量(默认5)
          hoverStop: false, // 是否开启鼠标悬停stop
          openTouch: false, // 移动端开启touch滑动
          direction: 1, // 0向下 1向上 2向左 3向右
          openWatch: true, // 开启数据实时监控刷新dom
          singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
          singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
          waitTime: 2000, // 单步运动停止的时间(默认值1000ms)
        },
        tableData: [{
            id: 1,
            name: '张*星',
            phone: '182***78',
            url: require("../assets/p1.jpg")
          },
          {
            id: 2,
            name: '李*刚',
            phone: '139***32',
            url: require("../assets/p2.jpg")
          },
          {
            id: 3,
            name: '王*丫',
            phone: '158**88',
            url: require("../assets/p3.jpg")
          },
          {
            id: 4,
            name: '张*梅',
            phone: '131***56',
            url: require("../assets/p4.jpg")
          },
          {
            id: 5,
            name: '何*月',
            phone: '151***23',
            url: require("../assets/p5.jpg")
          },
        ],
        timer: null,
        people: null,
        currentObj: {},
        carouselList: [],
        detailList: [],
        normList: [],
        normImg: null,
        normPrice: null,
        normTitle: null,
        form: {
          product_code: null,
          product_name: null,
          receiver_name: null,
          product_type_code: null,
          product_type_name: null,
          receiver_tel: null,
          receiver_area: null,
          receiver_address: null,
          order_num: 1,
          order_price: null,
          order_total: null,
          order_notes: null,
          order_ip_address: null,
          landingpage_link: null,
          code_id: null,
          sign: null,
          os: null,
          source: 'wangyi',
          click_Id: "123",
          click_num: 0,
          channel: ''
        },
        currentIndex: 0,
        defaultImg: null,
        rules: {
          receiver_name: [{
              required: true,
              message: "收货人姓名不能为空",
              trigger: "blur"
            },
            {
              pattern: /^[\u4e00-\u9fa5]+$/,
              message: "请输入汉字",
              trigger: "blur"
            }
          ],
          receiver_area: [{
            required: true,
            message: "区域不能为空",
            trigger: "blur"
          }],
          receiver_address: [{
            required: true,
            message: "详细地址不能为空",
            trigger: "blur"
          }],
          receiver_tel: [{
              required: true,
              message: '手机号必填',
              trigger: 'blur'
            },
            {
              pattern: /^1[3456789]\d{9}$/,
              message: '手机号码格式不正确',
              trigger: 'blur'
            }
          ]
        },
        options: citys,
        windowFuc: null
      }
    },
    created() {
      // getBaiduIp().then(res => {
      //   console.log(res, "wwwwww")
      //   this.form.order_ip_address = res.ip
      //   this.ipAddress = res.data.city
      //   let city = res.data.city
      //   let clickid = this.getRequestParam()['clickid']
      //   this.form.click_Id = clickid
      // }, err => {
      //   this.aaa = false
      // })
      this.getPageDetail(true)
      window.addEventListener("scroll", this.handleScrollx, true);
    },
    mounted() {
      setTimeout(() => {
        let clientH = window.innerHeight || document.documentElement.clientHeight;
        let boxHeight = this.$refs.box.offsetHeight
        let orderInfoHeight = 0
        if (this.$refs.orderInfo) {
          orderInfoHeight = this.$refs.orderInfo.offsetHeight
        }
        let showHeight = boxHeight - orderInfoHeight - clientH
        this.showHeight = showHeight
      }, 2000);
      // setTimeout(() => {
      //   this.open=true
      // }, 5000);
      this.form.os = this.getSystem()
    },
    methods: {
      //轮播用
      startInterval() {
        // 事件里定时器应该先清除在设置，防止多次点击直接生成多个定时器
        clearInterval(this.timer);
        this.timer = setInterval(() => {
          this.currentIndex++;
          if (this.currentIndex > this.carouselList.length - 1) {
            this.currentIndex = 0
          }
        }, 3000)
      },
      // 点击左右箭头
      clickIcon(val) {
        if (val === 'down') {
          this.currentIndex++;
          if (this.currentIndex === this.carouselList.length) {
            this.currentIndex = 0;
          }
        } else {
          /* 第一种写法
          this.currentIndex--;
          if(this.currentIndex < 0){
          	this.currentIndex = this.carouselList.length-1;
          } */
          // 第二种写法
          if (this.currentIndex === 0) {
            this.currentIndex = this.carouselList.length;
          }
          this.currentIndex--;
        }
      },
      // 点击控制圆点
      changeImg(index) {
        this.currentIndex = index
      },
      //鼠标移入移出控制
      changeInterval(val) {
        if (val) {
          clearInterval(this.timer)
        } else {
          this.startInterval()
        }
      },
      //获取操作系统
      getSystem() {
        Array.prototype.contains = function(needle) {
          for (i in this) {
            if (this[i].indexOf(needle) > 0)
              return i;
          }
          return -1;
        }
        var device_type = navigator.userAgent; //获取userAgent信息
        var md = new MobileDetect(device_type); //初始化mobile-detect
        var os = md.os(); //获取系统
        var model = "";
        if (os == "iOS") { //ios系统的处理
          os = +md.version("iPhone");
          model = md.mobile();
        } else if (os == "AndroidOS") { //Android系统的处理
          os = md.os() + md.version("Android");
          var sss = device_type.split(";");
          var i = sss.contains("Build/");
          if (i > -1) {
            model = sss[i].substring(0, sss[i].indexOf("Build/"));
          }
        }
        // alert(os + "---" + model);//打印系统版本和手机型号
        return model + "/" + os
      },
      //点击优惠券
      receive() {
        this.open = false
        this.useRedBag = true
        this.form.order_total = (this.form.order_num * 100 * this.form.order_price - 100 * this.discountAmount) / 100
        this.$nextTick(() => {
          const height = this.$refs.box.clientHeight - 1000
          window.scrollTo(0, height)
        })
      },
      //判断显示点我下单
      handleScrollx() {
        let height = window.pageYOffset
        if (height < this.showHeight) {
          this.showClickMe = true
        } else {
          this.showClickMe = false
        }
      },
      //点我下单
      clickMe() {
        this.$nextTick(() => {
          const height = this.$refs.box.clientHeight - 1000
          window.scrollTo(0, height)
        })
        this.showClickMe = false
      },
      //选择规格
      slectNorm(param) {
        this.form.product_type_code = param.id
        this.form.order_price = param.product_type_amt
        this.form.product_type_name = param.product_type_name
        if (this.useRedBag) {
          this.form.order_total = (this.form.order_num * 100 * this.form.order_price - 100 * this.discountAmount) / 100
        } else {
          this.form.order_total = this.form.order_num * 100 * this.form.order_price / 100
        }
        this.normImg = param.product_type_sku_img_url
        this.normPrice = param.product_type_amt
        this.normTitle = param.product_type_name
      },
      //提交
      // submit() {
      //   getConfig().then(res=>{
      //     if(res.data.is_open){
      //       let lastTime=localStorage.getItem("time")
      //       if(lastTime){
      //         let currentTime=new Date().getTime();
      //         let distance=(currentTime-lastTime)/1000
      //         if(distance>=res.data.stay_time){
      //           this.submitForm()
      //         }else{
      //           this.$message({
      //             type: 'error',
      //             message: '请勿重复下单'
      //           });
      //         }
      //       }else{
      //         this.submitForm()
      //       }
      //     }else{
      //       this.submitForm()
      //     }
      //   })
      // },
      submitForm() {
        this.$refs["form"].validate(valid => {
          if (valid) {
            addOrder(this.form).then(res => {
              // eval(this.currentObj.ad_js_code)
              this.$router.push({
                name: 'ordersuccess',
                query: {
                  order_no: res.data.order_no
                }
              })
            })
          }
        });
      },
      //购买数量
      changeNum() {
        if (this.form.product_type_code) {
          if (this.useRedBag) {
            this.form.order_total = (this.form.order_num * 100 * this.form.order_price - this.discountAmount * 100) /
              100
          } else {
            this.form.order_total = this.form.order_num * 100 * this.form.order_price / 100
          }
        }
      },
      //定位最下面
      gotobottom() {
        this.$nextTick(() => {
          const height = this.$refs.box.clientHeight - 1000
          window.scrollTo(0, height)
        })
      },
      //切换tab
      changeTab1() {
        this.acitve = true
        this.changeHeight()
      },
      changeTab2() {
        this.acitve = false
        this.changeHeight()
      },
      changeHeight() {
        setTimeout(() => {
          let clientH = window.innerHeight || document.documentElement.clientHeight;
          let boxHeight = this.$refs.box.offsetHeight
          let orderInfoHeight = 0
          if (this.$refs.orderInfo) {
            orderInfoHeight = this.$refs.orderInfo.offsetHeight
          }
          let showHeight = boxHeight - orderInfoHeight - clientH
          this.showHeight = showHeight
        }, 500);
      },
      //随机浏览人数
      setPeople() {
        this.people = Math.floor(Math.random() * 100 + 6)
      },
      //获取页面详情
      getPageDetail(flag) {
        let tempflag = flag.toString()
        let codeId = this.getRequestParam()["code_id"]
        this.form.code_id = codeId
        this.form.callback = this.$route.query.callback
        let encryptCode = this.encrypt(codeId)
        // console.log(this.decrypt("0RYHkjWhrRnDuhRpBwQEHcvE8+7wVULcU4v3rWxvPVk="),"解密结果")
        this.form.sign = encryptCode
        if (encryptCode) {
          this.setPeople()
          let param = {
            code_id: encryptCode,
            pass: tempflag,
            dencrypt_time: this.encrypt((Date.parse(new Date()) / 1000).toString())
          }
          getPageInfo(param).then(res => {
            console.log(res,"数据源")
            if (res.data.isputin == 0) {
              this.aaa = false;
            } else {
              this.aaa = true;
            }
            this.currentObj = res.data
            // eval(this.currentObj.ad_js_code)

            this.carouselList = this.currentObj.carousel_picture_src.split(",")
            this.detailList = this.currentObj.picture_json.split(",")
            this.normList = this.currentObj.spec
            this.form.product_code = this.currentObj.product_code
            this.form.product_name = this.currentObj.product_name
            document.title = this.currentObj.title
            this.form.product_type_code = this.normList[0].id
            this.form.order_price = parseInt(this.normList[0].product_type_amt)
            this.form.product_type_name = this.normList[0].product_type_name
            this.form.channel = this.currentObj.channel
            this.form.order_total = this.form.order_num * 100 * this.form.order_price / 100
            this.normImg = this.normList[0].product_type_sku_img_url
            this.normPrice = this.normList[0].product_type_amt
            this.normTitle = this.normList[0].product_type_nam
            this.loading = false
            //脚本
            // 创建一个新的script元素
            const script1 = document.createElement('script');
            const script2 = document.createElement('script');
            // 设置script的类型
            script1.type = 'text/javascript';
            script2.type = 'text/javascript';
            // console.log(this.currentObj.ad_basic_js_code.replace(/<[^>]+>/g, ''))
            // 设置script的内容
            script1.text = this.currentObj.ad_basic_js_code.replace(/<[^>]+>/g, '');
            script2.text = this.currentObj.ad_js_code.replace(/<[^>]+>/g, '');

            // 将script元素添加到head中
            document.head.appendChild(script1);
            document.head.appendChild(script2);
            //脚本结束
            setTimeout(() => {
              let temp = this.$refs.carouselImg[0].height > 0 ? this.$refs.carouselImg[0].height : 400
              this.carouselHeight = temp + "px"
            }, 500);
          }, err => {
            this.aaa = false
            this.loading = false
            this.open = false
          })
        }
      },

      //获取url参数
      getRequestParam(key) {
        var url = window.location.href
        this.form.landingpage_link = url
        let pattern = /(\w+)=(\w+)/ig; //定义正则表达式
        let parames = {}; // 定义参数对象
        url.replace(pattern, ($, $1, $2) => {
          parames[$1] = $2;
        });
        return parames;
      },
      getParamsNew(key) {
        var temData = new URLSearchParams(window.location.search);
        return temData.get("code_id")
      },
      //加密
      encrypt(text) {
        var key = CryptoJS.enc.Utf8.parse('1463587320654321'); //为了避免补位，直接用16位的秘钥
        var iv = CryptoJS.enc.Utf8.parse('1758326540123456'); //16位初始向量
        var encrypted = CryptoJS.AES.encrypt(text, key, {
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7
        });
        return encrypted.toString();
      },
      decrypt(text) {
        var key = CryptoJS.enc.Utf8.parse('1463587320654321'); //为了避免补位，直接用16位的秘钥
        var iv = CryptoJS.enc.Utf8.parse('1758326540123456'); //16位初始向量
        var encrypted = CryptoJS.AES.decrypt(text, key, {
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7

        });
        return encrypted.toString(CryptoJS.enc.Utf8);
      }
    }
  }
</script>

<style scoped>
  .maxwidht {
    max-width: 500px;
    margin: 0 auto;
  }

  .flex {
    display: flex;
    justify-content: space-between;
  }

  .padding {
    padding: 10px;
  }

  .paddingtb {
    padding: 10px 0;
  }

  .paddinglr {
    padding: 0 10px;
  }

  .bgcolor {
    background-color: #f7f7f7;
  }

  .carousel img {
    width: 100%;
  }

  .baseInfo {
    padding: 20px 10px 0px 10px;
    background: white;
  }

  .flexMoney {
    display: flex;
    justify-content: space-between;
    color: #f85959;
  }

  .money {
    font-size: 30px;
    font-weight: 600;

  }

  .desc {
    font-size: 16px;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    color: #333;
    line-height: 30px;
    margin: 8px 0;
  }

  .freeFlex {
    display: flex;
    /* justify-content: space-around; */
    height: 44px;
    line-height: 44px;
    text-align: center;
  }

  .baoyou {
    width: 130px;
    background: #ffe0df;
    border-radius: 5px 0 0 5px;
  }

  .cartDiv {
    width: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .cart {
    width: 25px;
    animation-duration: 0.8s;
    animation-timing-function: ease;
    animation-delay: 0s;
    animation-iteration-count: infinite;
    animation-direction: normal;
    animation-fill-mode: none;
    animation-play-state: running;
    animation-name: cart;
  }

  @keyframes cart {
    from {
      transform: scale(0.8);
    }

    to {
      transform: scale(1);
    }
  }

  .pay {
    background-image: url("../assets/bg-right.png");
    background-size: 100% 100%;
    flex: 1;
    margin-left: -10px;
    color: white;
  }

  .service {
    margin-top: 10px;
    border-top: 1px solid #f3f3f3;
    padding: 10px 0;
    line-height: 20px;

  }

  .service span {
    color: #999;
    font-size: 12px;
    margin: 0 10px;
  }

  .service i {
    margin-right: 4px;
    color: red;
  }

  .safeguard {
    margin-left: 46px !important;
  }

  .scanNum {
    font-weight: 600;
    font-size: 18px;
    height: 50px;
    line-height: 50px;
  }

  .scanNum span {
    color: #999;
    font-size: 12px;
  }

  .scandiv {
    background: #f85959;
  }

  .sacnContainer {
    height: 160px;
    overflow: hidden;
  }

  .unit {
    display: flex;
    padding: 4px 10px;
    border-bottom: 1px solid #e5e5e5;
  }

  .avatar {
    width: 60px;
    border-radius: 50%;
    margin-right: 10px;
  }

  .personinfo {
    width: 70%;
    margin-right: 10px;
    font-size: 14px;
  }

  .namephone {
    font-weight: 600;
    font-size: 16px;
  }

  .tobuy {
    width: 70px;
    height: 30px;
    line-height: 30px;
    border-radius: 4px;
    text-align: center;
    background: #fe2448;
    color: white;
    margin-top: 10px;
  }

  .tabs {
    display: flex;
    justify-content: space-around;
    background: white;
    height: 50px;
    line-height: 50px;
  }

  .activetab {
    color: #e95560;
    border-bottom: 2px solid #e95560;
  }

  .pictext {
    height: 50px;
    line-height: 50px;
    text-align: center;
    color: #999
  }

  .detailimg {
    width: 100%;
    display: flex;
  }

  .commonstyle>>>.el-collapse-item__header {
    font-size: 16px !important;
  }

  .explaintext {
    font-size: 16px;
    color: #999;
  }

  .orderInfo {
    font-weight: 600;
    text-align: center;
    padding-top: 30px;
  }

  .border {
    border-bottom: 1px solid #e5e5e5;
  }

  .orderFlex {
    display: flex;
  }

  .orderimg {
    width: 100px;
    height: 100px;
    margin-right: 20px;
  }

  .orderMoney {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }

  .normunit {
    padding: 10px;
    border: 1px solid #e95560;
    border-radius: 6px;
    margin: 10px 0;
  }

  .realPay {
    color: #e95560;
    font-size: 20px;
    font-weight: 600;
  }

  .red {
    color: #e95560
  }

  .buynumflex {
    display: flex;
    justify-content: space-between;
  }

  .buynum {
    line-height: 40px;
  }

  .commonstyle>>>.el-form-item {
    margin-bottom: 16px;
    font-size: 16px;
    border-bottom: 1px solid #e5e5e5;
  }

  .commonstyle>>>.el-form-item__label {
    font-size: 16px;
  }

  .commonstyle>>>.el-input__inner {
    border: none !important;
  }

  .commonstyle>>>.el-form-item__error {
    padding-left: 16px;
  }

  .commonstyle {
    margin-top: 10px;
    padding: 10px;
    background: white;
  }

  .payicon {
    width: 20px;
    margin-right: 4px;
  }

  .paycontainer {
    display: flex;
  }

  .payflex {
    display: flex;
    margin-top: 20px;
    justify-content: space-between;
    align-items: center;
  }

  .conmonheight {
    height: 40px;
    line-height: 40px;
  }

  .border {
    border-bottom: 1px solid #e5e5e5;
  }

  .messageflex {
    display: flex;
    width: 100%;
  }

  .remark {
    height: 40px;
    line-height: 40px;
    margin-right: 20px;
  }

  .button {
    width: 98%;
    margin: 40px auto 0;
    color: white;
    background: #f85959;
    text-align: center;
    line-height: 50px;
    font-size: 18px;
    /* margin-bottom: 50px; */
  }

  .buton2 {
    width: 100%;
    max-width: 500px;
    position: fixed;
    bottom: 0;
    color: white;
    background: #f85959;
    height: 50px;
    line-height: 50px;
    text-align: center;
    border-radius: 4px;
    z-index: 1000000;
  }

  .activeradio {
    background: #f85959;
    color: white !important;
    line-height: 30px;
    border-radius: 6px;
  }

  .deactiveradio {
    color: #333;
    line-height: 30px;
    border-radius: 6px;
  }

  .defaultImg {
    width: 100%;
    display: flex;
  }

  .nothing {
    text-align: center;
    /* margin-top: 20%; */
  }

  .nothing img {
    width: 100%;
    height: 100%;
  }

  .center {
    text-align: center;
  }

  .dialog>>>.el-dialog {
    background: none;
    position: relative;
    margin: 0 auto 50px;
    background: none;
    width: 50%;
    box-shadow: none
  }

  .bagcontent {
    background-image: url("../assets/redbag.png");
    background-size: 100% 100%;
    text-align: center;
    color: #dd5300;
    font-size: 30px;
    font-weight: 600;
    height: 250px;
  }

  .minusmoney {
    padding-top: 60px
  }

  .messageDialog {
    margin-top: 25vh;
  }

  .confirm {
    width: 100%;
    margin-top: 20px;
    background: #f85959;
    color: white;
    height: 40;
    line-height: 40px;
    text-align: center;
  }




  /* 清除li前面的圆点 */
  li {
    list-style-type: none;
  }

  .showImg {
    position: relative;
    height: 250px;
    margin: 0 auto;
    overflow: hidden;
  }

  /* 轮播图片 */
  .showImg img {
    width: 100%;
    height: 100%;
  }

  /* 箭头图标 */
  .iconDiv {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 30px;
    height: 30px;
    border: 1px solid #666;
    border-radius: 15px;
    background-color: rgba(125, 125, 125, .2);
    line-height: 30px;
    text-align: center;
    font-size: 25px;
    cursor: pointer;
  }

  .iconDiv:hover {
    background-color: white;
  }

  .icon-left {
    left: 10px;
  }

  .icon-right {
    right: 10px;
  }

  /* 控制圆点 */
  .banner-circle {

    position: absolute;
    bottom: 0;
    width: 100%;
    /* height: 20px; */
  }

  .banner-circle ul {
    /* margin: 0 50px; */
    height: 100%;
    text-align: right;
  }

  .banner-circle ul li {
    display: inline-block;
    width: 14px;
    height: 14px;
    margin: 0 5px;
    border-radius: 7px;
    background-color: rgba(125, 125, 125, .8);
    cursor: pointer;
  }

  .active {
    background-color: black !important;
  }

  .text-center {
    text-align: center;
    background-color: #fff;
    margin-bottom: 50px;
  }
</style>



// WEBPACK FOOTER //
// src/components/sina.vue